angular.module('dealerware.web.data').factory('DealerwareWarrantyModel', function ($http, $q, Model, PdfHelperService)  {

    var model = new Model({
        baseEndpoint: '/locations/:location_id/reservations/:contract_id/warranties',
        customActions: {
            get: {
                method: 'GET',
                ignoreDefaultRootNodeResponse: true,
                ignoreAssociations: true
            },
            create: {
                method: 'POST',
                ignoreDefaultRootNodeResponse: true,
                ignoreAssociations: true
            },
            update: {
                method: 'PUT',
                ignoreDefaultRootNodeResponse: true,
                ignoreAssociations: true
            },
            delete: {
                method: 'DELETE'
            }
        },
        requestTransforms: {
            create: mapWarrantyRequestData,
            update: mapWarrantyRequestData
        },
        responseTransforms: {
            get: mapWarrantyResponseData,
            create: mapWarrantyResponseData,
            update: mapWarrantyResponseData
        }
    });

    function mapWarrantyRequestData(args, data) {
        if (data) {
            data.daily_rate = parseFloat(data.daily_rate.replace(/[^0-9.]+/g, ''));
            data.warranty_days = parseFloat(data.warranty_days);

            if (data.tax_percentage) {
                data.tax_percentage = parseFloat(data.tax_percentage.replace(/[^0-9.]+/g, '')) / 100;
            }
        }
    }

    function mapWarrantyResponseData(args, data) {
        if (data) {
            data.daily_rate = parseFloat(data.daily_rate).toString();
            data.tax_percentage = (parseFloat(data.tax_percentage) * 100).toString();
            data.warranty_days = parseFloat(data.warranty_days);
        }
    }

    angular.extend(model.prototype, {

        $getPdf: function(contract) {
            var deferred = $q.defer();

            PdfHelperService.getPdfBlob({
                endpoint: '/locations/' + contract.locationId + '/reservations/' + contract.contractId + '/warranties.pdf'
            })
                .then(
                    function(response) { deferred.resolve(response); },
                    function(response) { deferred.reject(response); }
                );

            return deferred.promise;
        }
    });

    return model;
});
